import { SPEECHMIKE_III_PRODUCT } from './speechmike';
import { VIRTUAL_DICTAPHONE_PRODUCT } from './virtual';
import type { DictaphoneProduct } from './types';
import type { DictaphoneDeviceFingerprint } from 'generated/graphql';

const DICTAPHONE_PRODUCTS: ReadonlyArray<DictaphoneProduct> = [
  SPEECHMIKE_III_PRODUCT,
  VIRTUAL_DICTAPHONE_PRODUCT,
];

// Returns all dictaphone products matching the given device fingerprint.
export const identifyDictaphoneProducts = (
  deviceFingerprint: DictaphoneDeviceFingerprint,
  registry: ReadonlyArray<DictaphoneProduct> = DICTAPHONE_PRODUCTS
): ReadonlySet<DictaphoneProduct> =>
  new Set(registry.filter((p) => p.matchesDeviceFingerprint(deviceFingerprint)));

/**
 * Find the dictaphone product matching the given device fingerprint.
 * Returns undefined if no product matches.
 */
export const findDictaphoneProduct = (
  deviceFingerprint: DictaphoneDeviceFingerprint
): DictaphoneProduct | undefined =>
  DICTAPHONE_PRODUCTS.find((product) => product.matchesDeviceFingerprint(deviceFingerprint));

/**
 * The single dictaphone product that is auto-selected as the dictation input when plugged in.
 * Deliberately single-device: Sirona currently targets one hardware dictaphone. Supporting
 * several will need an ordered priority list here plus changes to the prefer-on-connect policy
 * (`domains/reporter/usePreferredInputOnConnect/preferredInputOnConnect.ts`).
 */
export const PREFER_ON_CONNECT_PRODUCT_ID = SPEECHMIKE_III_PRODUCT.id;

/** Whether the device fingerprint identifies the product that is auto-selected on plug-in. */
export const isPreferOnConnectProduct = (deviceFingerprint: DictaphoneDeviceFingerprint) =>
  findDictaphoneProduct(deviceFingerprint)?.id === PREFER_ON_CONNECT_PRODUCT_ID;
